import _ from "lodash";

export const AUTH_DICT = {
  "vantage admin": 1,
  "vantage facilitator": 2,
  "company admin": 3,
  "department admin": 4,
  "department facilitator": 5,
  "department employee": 6,
};

export const isVantageAdmin = (user) => {
  return _.get(user, "auth") === "vantage admin";
};

export const isVantageFacilitator = (user) => {
  return _.get(user, "auth") === "vantage facilitator";
};

export const isCompanyAdmin = (user) => {
  return _.get(user, "auth") === "company admin";
};

export const isDepartmentAdmin = (user) => {
  return _.get(user, "auth") === "department admin";
};

export const isDepartmentFacilitator = (user) => {
  return _.get(user, "auth") === "department facilitator";
};

export const isDepartmentEmployee = (user) => {
  return _.get(user, "auth") === "department employee";
};

export const getListOfAuth = (permissionInts) => {
  const arr = [];
  const permissions = _.invert(AUTH_DICT);

  const str = permissionInts.toString();
  for (let char of str) {
    arr.push(permissions[char]);
  }

  return arr;
};

export const isAuthed = (user, minPermission) => {
  const userAuth = _.get(user, "auth");
  const userInt = _.get(AUTH_DICT, userAuth);
  const permissionInt = _.get(AUTH_DICT, minPermission);

  if (_.isNil(userInt || _.isNil(permissionInt))) {
    return false;
  }

  return userInt <= permissionInt;
};
